import { useProjectSchemas } from "./useProjectSchemas";

// Owner of a project from the projects store, waiting briefly for the store
// to load: /home routes render before it does (#3924), and an undefined owner
// makes the write check silently deny the OWNER (#3669 review).
export async function resolveProjectOwner(projectId: string, timeoutMs = 3000) {
  const read = () => useProjectSchemas.getState().getProjectOwner(projectId);
  const deadline = Date.now() + timeoutMs;
  let owner = read();
  while (
    owner === undefined &&
    !useProjectSchemas.getState().projectsLoaded &&
    Date.now() < deadline
  ) {
    await new Promise((resolve) => setTimeout(resolve, 150));
    owner = read();
  }
  return owner;
}

// The loaded project doc, if any: Teams sharing checks read its editors.
// On a cold route, call it after resolveProjectOwner's wait.
export const loadedProject = (projectId: string | null | undefined) =>
  projectId
    ? useProjectSchemas.getState().projects?.find((p) => p.id === projectId)
    : undefined;
